export default {
  PROMOTIONAL_ACTIVITY: "promotional_activity",
  LONG_TERM_SPONSOR: "long_term_sponsor",
};
